import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class EquityGrantsService {
  static list(item) {

    console.log('Listing with item:', item);
    const api = `${API_PATHS.EquityGrantList}`;
    const formData = new FormData();

    Object.entries(item || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    return axios
      .post(api, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => response.data);
  }

  static add(item) {
    const api = `${API_PATHS.EquityGrantAdd}`;
    const formData = new FormData();

    Object.entries(item || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    return axios
      .post(api, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => response.data);
  }

  static detail(item) {
    const api = `${API_PATHS.EquityGrantDetail}`;
    const formData = new FormData();

    Object.entries(item || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    return axios
      .post(api, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => response.data);
  }

  static delete(item) {
    const api = `${API_PATHS.EquityGrantDelete}`;
    const formData = new FormData();

    Object.entries(item || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    return axios
      .post(api, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => response.data);
  }
}

export default EquityGrantsService;
